<template>
    <div class="container">
        <div class="discuss-box df">
            <div class="left-box">
                <div class="head-box df aic jcsb">
                    <span class="t1">{{ $t("技术研讨") }}</span>
                    <el-button class="btn" @click="getPost()"><span>+</span>{{ $t("发布帖子") }}</el-button>
                </div>
                <!-- 查询 -->
                <div class="mt-28">
                    <div class="search-box">
                        <div class="df">
                            <span class="s1">{{ $t("领域") }}</span>
                            <div class="desc-list f1">
                                <span v-for="(item, index) in area" :key="index"
                                    @click="() => (FormData.post_scene = item.value)" class="span-tab"
                                    :class="{ active: FormData.post_scene == item.value }">{{ item.label }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="search-box">
                        <div class="df">
                            <span class="s1">{{ $t("行业") }}</span>
                            <div class="desc-list f1">
                                <span v-for="(item, index) in industry" :key="index"
                                    @click="() => (FormData['post_ins'] = item.value)" class="span-tab"
                                    :class="{ active: FormData['post_ins'] == item.value }">{{ item.label }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="search-box" v-if="false">
                        <div class="df">
                            <span class="s1">{{ $t("交流") }}</span>
                            <div class="desc-list f1">
                                <span v-for="(item, index) in area" :key="index" class="span-tab"
                                    :class="{ active: FormData.exchange == item.id }">{{ item.label }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 最新 -->
                <div class="hot-box df aic jcsb mt-10">
                    <div>
                        <el-radio v-model="FormData.sort_method" label="">{{
                            $t("全部")
                            }}</el-radio>
                        <el-radio v-model="FormData.sort_method" label="10">{{
                            $t("最新")
                            }}</el-radio>
                        <el-radio v-model="FormData.sort_method" label="20">{{
                            $t("最热")
                            }}</el-radio>
                        <el-radio v-model="FormData.sort_method" label="30">{{
                            $t("精华")
                            }}</el-radio>
                        <el-radio v-model="FormData.sort_method" label="40">{{
                            $t("我的帖子")
                            }}</el-radio>
                    </div>
                    <div>
                        <el-select style="width: 130px" v-model="FormData.state" :placeholder="$t('请选择州')">
                            <el-option v-for="item in regionData" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select v-model="FormData.region" :placeholder="$t('请选择国家/区域')">
                            <el-option v-for="item in countryList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <!-- 列表 -->
                <div class="discuss-list">
                    <div class="list-box">
                        <div class="list" v-for="(items, indexs) in topic_article_list" :class="{
                            'hot-box': items.tp_rec == 1000,
                            'essence-box': [0, 1, 2].indexOf(indexs) != -1 && pagination.page == 1 && FormData.sort_method == '',
                        }" :key="indexs" @click="handleLink(items)">
                            <div class="t1s df jcsb aic over-h">
                                <div class="mic-semblod tow-text">
                                    <span class="essence" v-if="items.tp_rec == 900">{{
                                        $t("精1")
                                        }}</span>
                                    <span class="hot" v-if="hits_top_post_id.indexOf(items.tp_id) != -1">{{ $t('热1') }}</span>
                                    <span class="hot" style="background-color: #FDB906FF;" v-if="items.tp_is_top == 10 || items.tp_rec == 1000">{{ $t('顶1') }}</span>
                                    <span class="content-type-tag" :class="items.content_type == 20 ? 'article-tag' : 'post-tag'" v-if="items.content_type">
                                        {{ items.content_type == 20 ? $t('文章1') : $t('帖子1') }}
                                    </span>
                                    {{ items.tp_title }}
                                </div>
                                <div class="show-box fn">
                                    <img v-if="items.tp_is_top == 10 || items.tp_rec == 1000" src="@/assets/images/hot.png" alt="" />
                                    <img v-if="[0, 1, 2].indexOf(indexs) != -1 && pagination.page == 1 && FormData.sort_method == ''" src="@/assets/images/essence.png" alt="" />
                                </div>
                            </div>
                            <!-- <div class="desc tow-text" :title="items.ttar_desc">
                                {{ items.tp_desc }}
                            </div> -->

                            <div class="userinfo-box df jcsb aic over-h">
                                <div class="users df aic f1 over-h">
                                    <div class="df fn" @click.stop="handleUserinfo(items)">
                                        <template v-if="items.tp_type == 10">
                                            <el-avatar :size="18" :src="items.user_avatar_att_url" class="fn"
                                                @error="handleImageError">
                                                <img src="@/assets/images/news-default.png" alt="" />
                                            </el-avatar>
                                        </template>
                                        <template v-else>
                                            <el-avatar :size="18" :src="''" class="fn"
                                                @error="$erroravatarHandler">
                                                <img src="@/assets/images/news-default.png" alt="" />
                                            </el-avatar>
                                        </template>
                                    </div>

                                    <span class="name fn">
                                        {{ getUserName(items) }}
                                    </span>

                                    <div class="f1 type one-text" v-if="items.user_excel_arr && items.user_excel_arr.length">
                                        <span v-for="(items1, indexs1) in items.user_excel_arr" :key="indexs1">{{
                                            items1.label }}</span>
                                    </div>
                                </div>

                                <div class="dates df fn">
                                    <div class="comment-list df">
                                        <div class="li">
                                            <span class="iconfont">&#xe611;</span>
                                            <span class="text">{{ items.tp_hits }}</span>
                                        </div>
                                        <div class="li">
                                            <span class="iconfont">&#xe61b;</span>
                                            <span class="text">{{ items.tp_likes }}</span>
                                        </div>
                                        <div class="li">
                                            <span class="iconfont">&#xe63e;</span>
                                            <span class="text">{{ items.reply_count }}</span>
                                        </div>
                                    </div>
                                    <span class="date">{{
                                        items.tp_published_time * 1000, "YYYY.MM.DD HH:mm" | formatTime
                                    }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="no-data pt-86" v-if="!topic_article_list || topic_article_list.length == 0">
                            <img src="@/assets/images/empty_data.png" alt="" />
                            <p>{{ $t("暂无数据") }}</p>
                        </div>
                    </div>
                </div>
                <div class="pageing-box df aic jcc">
                    <el-button type="text" class="add-btn" @click="handleCurrent(1)">{{
                        $t("回首页")
                        }}</el-button>
                    <el-pagination :current-page="pagination.page" :page-size="20" :total="pagination.total"
                        layout=" prev, pager, next,slot" @current-change="handleCurrent">
                        <span class="jump-text">{{ $t("跳转") }}</span>
                        <el-input-number :controls="false" v-model="pagination.page" :min="1" :max="pagination.allPage" size="small"
                            @change="handleCurrent(pagination.page)" class="jump-ipt" style="width: 28px; margin-left: 8px" />
                    </el-pagination>
                    <el-button type="text" class="add-btn ml-11" @click="handleCurrent(pagination.allPage)">{{ $t("去尾页")
                        }}</el-button>
                </div>
            </div>
            <div class="right-box ml-16">
                <!-- 版主 -->
                <div class="expert-box pl-0 pr-0 pb-0">
                    <div class="title-box mb-24 pl-24 pr-24">
                        <span class="s1">{{ $t("版主") }}</span>
                    </div>

                    <div class="hostlist-box">
                        <div class="host-list pl-24 pr-24" v-for="(item, index) in moderator_list" :key="item.user_id">
                            <div class="list mb-32">
                                <div class="head-list df aic jcsb">
                                    <div class="df aic over-h" @click.stop="handleUserinfo(item)">
                                        <!-- <el-image :size="48" :src="item.user_avatar_att_url" fit="cover">
                                        <div slot="error" class="image-slot">
                                            <img src="@/assets/images/news-default.png" alt="" />
                                        </div>
                                    </el-image> -->

                                        <el-avatar :size="48" :src="item.user_avatar_att_url" class="cup fn"
                                            @error="$erroravatarHandler">
                                            <img src="@/assets/images/news-default.png" alt="" />
                                        </el-avatar>
                                        <div class="ml-16 over-h">
                                            <div class="name one-text" :title="item.user_nick_name">
                                                {{ item.user_nick_name }}
                                            </div>
                                            <div class="fans">
                                                {{ $t("粉丝数") }}<span>{{ item.user_fans_count }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <el-button class="hred-btn fn ml-12 df aic jcc" :loading="btnLoading[item.user_id]"
                                        @click="handlePostSubmittedField(item.user_id, 'moderator_list', 'have_be_follow', index)">
                                        <span class="iconfont fs-10 lh-10 mr-3" style="position: relative;top:-2px">{{
                                            item.have_be_follow ? '&#xebe6;' : '&#xe623;' }}</span>{{ item.have_be_follow ?
                                                $t("已关注") :
                                                $t("关注") }}
                                    </el-button>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- 主持人专区 -->
                    <div v-if="is_moderator" class="zone-list df aic jcsb" @click="handlerLink()">
                        <div class="c1 df aic">
                            {{ $t("进入版主专区") }}<span class="iconfont">&#xe605;</span>
                        </div>
                        <span class="c2">{{ $t("待审核") }}：{{ post_dealt_num }}</span>
                    </div>
                </div>

                <!-- 活跃用户 -->
                <div class="expert-box mt-16">
                    <div class="title-box mb-24 pl-24">
                        <span class="s1">{{ $t("活跃用户") }}</span>
                    </div>
                    <div class="expertlist-box">
                        <div class="host-list">
                        <div class="list pl-24 pr-24" v-for="(user, index) in lively_user_list" :key="user.user_id">
                            <div class="head-list df aic jcsb">
                                <div class="df aic over-h" @click="handleUserinfo(user)">
                                    <el-avatar :size="48" :src="user.user_avatar_att_url" class="cup fn"
                                        @error="$erroravatarHandler">
                                        <img src="@/assets/images/news-default.png" alt="" />
                                    </el-avatar>
                                    <div class="ml-16 over-h">
                                        <div class="name one-text" :title="user.user_nick_name">
                                            {{ user.user_nick_name }}
                                        </div>
                                        <div class="fans">
                                            {{ $t("粉丝数") }}<span>{{ user.user_fans_count }}</span>
                                        </div>
                                    </div>
                                </div>


                                <el-button class="hred-btn fn ml-12" @click="
                                    handlePostSubmittedField(
                                        user.user_id,
                                        'lively_user_list',
                                        'is_follow',
                                        index
                                    )
                                    "><span class="iconfont fs-10 lh-10 mr-3" style="position: relative;top:-2px">{{
                                        user.is_follow ? '&#xebe6;' : '&#xe623;' }}</span>{{ user.is_follow ? $t("已关注")
                                            : $t("关注")
                                        }}</el-button>
                            </div>
                            <div class="expert-list df aic">
                                <div class="f1">
                                    <p class="p1">{{ $t("文章") }}</p>
                                    <p class="p2">{{ user.user_topic_article_count }}</p>
                                </div>
                                <div class="f1">
                                    <p class="p1">{{ $t("帖子") }}</p>
                                    <p class="p2">{{ user.user_post_count }}</p>
                                </div>
                                <div class="f1">
                                    <p class="p1">{{ $t("评论") }}</p>
                                    <p class="p2">{{ user.user_ans_count }}</p>
                                </div>
                                <div class="f1">
                                    <p class="p1">{{ $t("提问") }}</p>
                                    <p class="p2">{{ user.user_act_que_count }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

                <!-- 热门帖子 -->
                <div class="hot-post">
                    <div class="title-box pb-2">
                        <span class="s1">{{ $t("热门帖子") }}</span>
                    </div>
                    <div class="post-list">
                        <div class="list one-text" v-for="(item, index) in hot_article_list" :key="index"
                            @click="item.content_type == 20 ? $navigate('/subject/info', item.tp_id) : $navigate('/discuss/info', item.tp_id)" :title="item.tp_title">
                            <span :class="'de' + index" class="dex">{{ index + 1 }}.</span>
                            <span class="content-type-tag-small" :class="item.content_type == 20 ? 'article-tag' : 'post-tag'" v-if="item.content_type">
                                {{ item.content_type == 20 ? $t('文章') : $t('帖子') }}
                            </span>
                            {{ item.tp_title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 发帖子 -->
        <postModel ref="postDialog" :data="data_list" @post-submitted="handlePostModelSubmitted" />

        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" :publisher-follow-loading="publisherFollowLoading" @post-submitted="handlePostSubmitted" :id="id" />
    </div>
</template>

<script>
// 发布帖子弹框
import postModel from "@/components/postModel.vue";
import { addApipost, getcommonData, setuserfollowAdd } from "@api/home";

import { home, list, getAreaTree } from "@api/post";

export default {
    components: {
        postModel,
    },
    data() {
        return {
            // 当前选中用户id
            id: 0,
            FormData: {
                post_scene: 0, //领域
                post_ins: 0, //行业
                // exchange: 1,   //交流
                sort_method: "", //最新
                state: 0, //州
                region: 0, // 国家或区域
            },
            // 行业
            area: [],
            // 领域
            industry: [],
            exchange: [],
            // 地区
            regionData: [
                {
                    value: 1,
                    label: this.$t("所有区域"),
                },
            ],
            thisUserInfo:[],
            // 专家
            moderator_list: [],
            // 当前用户是否为专家
            is_moderator: false,
            // 待审核数
            post_dealt_num: 0,
            // 活跃用户
            lively_user_list: [],
            // 列表数据
            topic_article_list: [],
            // 最热3帖子id
            hits_top_post_id:[],

            // 分页数据
            pagination: {
                page: 1,
                total: 0,
                allPage: 0,
            },

            jumpIndex: 1,

            // 热门帖子
            hot_article_list: [],

            data_list: {},
            publisherFollowLoading:false,
            btnLoading:{}
        };
    },
    computed: {
        countryList() {
            let state = this.regionData.find(
                (item) => item.value === this.FormData.state
            );
            let list = [{ value: 0, label: this.$t("请选择国家/区域") }];
            if (state && state.child) {
                list = [...list, ...state.child];
            }
            return list;
        },
    },
    watch: {
        "FormData.state": {
            handler() {
                // 改变州 重置国家/区域
                this.FormData.region = 0;
            },
        },
        FormData: {
            handler(newVal) {
                let { state, region, ...formData } = newVal;
                formData.area_level1 = state;
                formData.area_level2 = region;
                this.handlePages(1, formData);
            },
            deep: true,
        },
    },

    mounted() {
        // 设置默认的顶部菜单背景色
        this.$bus.$emit("changeNavbg", "rgba(255, 255, 255, 0);");

        // 获取初始化数据
        home().then((res) => {
            this.industry = [
                { value: 0, label: this.$t("全部") },
                ...res.data.post_ins_list,
            ];
            this.area = [
                { value: 0, label: this.$t("全部") },
                ...res.data.post_scene_list,
            ];
            this.moderator_list = res.data.moderator_list;
            this.is_moderator = res.data.is_moderator;
            this.post_dealt_num = res.data.post_dealt_num;
            this.lively_user_list = res.data.lively_user_list;
            this.hot_article_list = res.data.hot_post_list.data;
            this.hits_top_post_id = res.data.hits_top_post_id
        });

        this.handlePages(1);

        getAreaTree().then((res) => {
            this.regionData = [
                {
                    value: 0,
                    label: this.$t("所有区域"),
                },
                ...res.data.area,
            ];
        });

        // 组件挂载后添加滚动事件监听
        window.addEventListener("scroll", this.handleScroll);
    },

    methods: {
        getUserName(item) {
            if ((item.tp_type == 10) && item.user_nick_name) {
                return item.user_nick_name
            }
            return this.$t("匿名用户")
        },
        handleScroll() {
            // 检查当前滚动位置
            if (window.scrollY >= 20) {
                this.$bus.$emit("changeNavbg", "rgba(255, 255, 255, 1);");
            } else {
                this.$bus.$emit("changeNavbg", "rgba(255, 255, 255, 0.2);");
            }
        },

        handleUserinfo(item) {
            if(item.is_expert == 20 && item.tp_type == 20 
                || item.user_id == 0 
                || item.user_nick_name === "" 
                || item.user_nick_name === null) {
                // 根据 content_type 判断跳转路由
                if (item.content_type == 20) {
                    this.$navigate('/subject/info', item.tp_id);
                } else {
                    this.$navigate('/discuss/info', item.tp_id);
                }
                return;
            }
            this.id = item.user_id;
            this.$refs.avatarDialog.openModal();
        },
        async handlePostSubmitted(id) {
            this.publisherFollowLoading = true
            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);

                // 获取初始化数据
                home().then((res) => {
                    this.industry = [
                        { value: 0, label: this.$t("全部") },
                        ...res.data.post_ins_list,
                    ];
                    this.area = [
                        { value: 0, label: this.$t("全部") },
                        ...res.data.post_scene_list,
                    ];
                    this.moderator_list = res.data.moderator_list;
                    this.is_moderator = res.data.is_moderator;
                    this.post_dealt_num = res.data.post_dealt_num;
                    this.lively_user_list = res.data.lively_user_list;
                    this.hot_article_list = res.data.hot_post_list.data;
                });

            }
            setTimeout(() => {
                this.publisherFollowLoading = false
            }, 1000)
        },
        // 关注弹框用户
        async handlePostSubmittedField(id, field, updateField, index) {
            this.btnLoading[id] = true
            // setuserfollowAdd
            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);
                this[field][index][updateField] = !this[field][index][updateField];
            }
            this.btnLoading[id] = false
        },
        handleLink(items) {
            // 根据 content_type 判断跳转路由：文章跳转到 /subject/info，帖子跳转到 /discuss/info
            if (items.content_type == 20) {
                // 文章
                this.$navigate("/subject/info", items.tp_id);
            } else {
                // 帖子
                this.$navigate("/discuss/info", items.tp_id);
            }
        },
        handleCurrent(page) {
            let { state, region, ...formData } = this.FormData;
            formData.area_level1 = state;
            formData.area_level2 = region;
            this.handlePages(page, formData);
        },
        handlePages(page = 1, params = {}) {
            this.pagination.page = page;
            // 使用合并查询（文章+帖子）
            list({ page, use_union: 1, ...params }).then((res) => {
                this.topic_article_list = res.data?.post_list?.data || [];
                this.pagination.total = res.data?.post_list?.total || 0;
                this.pagination.allPage = res.data?.post_list?.last_page || 1;
            }).catch((err) => {
                console.error('获取列表失败', err);
                this.topic_article_list = [];
                this.pagination.total = 0;
                this.pagination.allPage = 1;
            });
        },
        // 头像加载失败
        handleImageError() {
            return true;
        },
        //
        async getPost() {
            this.thisUserInfo=JSON.parse(localStorage.getItem('userinfo'));
            if(this.thisUserInfo.user_id===undefined || this.thisUserInfo.user_id<1){
                this.$jumpLogin();
                return false;
            }
            let res = await getcommonData();
            if (res.status == 200) {
                this.data_list = res.data;
            }
            this.$refs.postDialog.openModal();
        },
        // 发布帖子
        async handlePostModelSubmitted(content) {
            let res = await addApipost(content);
            if (res.status == 200) {
                this.$message.success(res.msg);
            }
        },

        // 今日版主专区
        handlerLink() {
            let str = "/cn";
            let Language = localStorage.getItem("currentLanguage"); //获取本地语言
            if (Language && Language != "zh") {
                str = "/" + Language;
            }
            const target = this.$router.resolve(str + "/discuss/moderatorzone");
            window.open(target.href, "_blank");
        },
    },
};
</script>

<style lang="scss" scoped>
.right-box {
    .zone-list {
        padding: 0 20px;
        height: 50px;
        border-radius: 0px 0px 12px 12px;
        background: linear-gradient(270deg,
                rgba(252, 60, 64, 0.07),
                rgba(188, 13, 16, 0.07) 100%);

        .c1 {
            color: rgb(188, 13, 16);
            font-size: 14px;
            font-weight: 500;
            line-height: 22px;
            cursor: pointer;

            .iconfont {
                font-size: 5px;
                margin-left: 5px;
            }
        }

        .c2 {
            font-size: 12px;
            font-weight: 400;
            color: #191919;
            line-height: 22px;
        }
    }

    .hot-post {
        padding: 20px 24px;
        border-radius: 12px;
        box-shadow: 0px 4px 48px 0px rgba(0, 0, 0, 0.06);
        background: rgb(255, 255, 255);
        margin-top: 16px;

        .post-list {
            .list {
                color: rgb(25, 25, 25);
                font-size: 14px;
                font-weight: 400;
                line-height: 24px;
                margin-top: 18px;
                cursor: pointer;

                &:hover {
                    color: #b7251e;
                }

                .dex {
                    color: rgba(89, 89, 89, 0.6);
                    font-family: "montserrat";
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                    display: inline-block;
                    margin-right: 8px;
                }

                .de0,
                .de1,
                .de2 {
                    color: #b7251e;
                }

                .content-type-tag-small {
                    display: inline-block;
                    height: 16px;
                    border-radius: 2px;
                    font-size: 10px;
                    color: #ffffff;
                    line-height: 16px;
                    text-align: center;
                    margin-right: 6px;
                    padding: 0 4px;
                    vertical-align: middle;
                }

                .article-tag {
                    background: #7BA7C4;
                }

                .post-tag {
                    background: #9AA7B8;
                }
            }
        }
    }

    .title-box {
        .s1 {
            font-family: "MicrosoftYaHeiSemibold";
            color: rgb(25, 25, 25);
            font-size: 22px;
            line-height: 24px;
        }
    }
}
.hostlist-box{
    max-height: 400px;
    overflow: hidden;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 4px; 
    }
    &::-webkit-scrollbar-thumb {
      background: rgba($color: #CF4325, $alpha: 0.04);
      border-radius: 8px; 
    }
}

.expertlist-box{
    max-height: 690px;
    overflow: hidden;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 4px;
   
    }
    &::-webkit-scrollbar-thumb {
      background: rgba($color: #CF4325, $alpha: 0.04);
      border-radius: 8px; 
    }
}
.expert-box {
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    background: rgb(255, 255, 255);
    padding: 20px 0px;

    .host-list .list {
        margin-bottom: 16px;
    }

    .expert-list {
        height: 62px;
        border-radius: 8px;
        background: rgba(25, 25, 25, 0.02);
        text-align: center;
        margin-top: 12px;

        .p1 {
            color: rgb(89, 89, 89);

            font-size: 12px;
            font-weight: 400;
            line-height: 23px;
        }

        .p2 {
            color: rgb(25, 25, 25);

            font-size: 12px;
            font-weight: 400;
            line-height: 23px;
        }
    }
}

.host-list .list {
    .hred-btn {
        min-width: 65px;
        height: 28px;
        padding: 0 10px;
        box-sizing: border-box;
        border-radius: 20px;
    }

    .name {
        color: rgb(25, 25, 25);
        font-size: 16px;
        font-weight: 400;
        line-height: 23px;
    }

    .fans {
        color: rgb(68, 68, 68);
        font-size: 12px;
        font-weight: 400;
        line-height: 23px;

        span {
            display: inline-block;
            margin-left: 20px;
        }
    }
}

.discuss-list {
    padding: 0 40px;
}

.list-box {
    margin-top: 18px;

    .list {
        padding: 16px 0px;
        border-bottom: 1px solid rgb(226, 226, 226);
        cursor: pointer;
        transition: border-bottom 0.36s;
        z-index: 10;

        &:hover {
            border-bottom: 1px solid #b7251e;

            .t1s {
                color: #b7251e;
            }
        }

        .t1s {
            color: rgb(25, 25, 25);
            font-size: 18px;
            font-weight: 400;
            line-height: 24px;
            padding: 2px 0;

            .essence,
            .hot,
            .content-type-tag {
                display: inline-block;
                min-width: 18px;
                height: 18px;
                border-radius: 2px;
                font-size: 12px;
                color: #ffffff;
                line-height: 18px;
                text-align: center;
                margin-right: 4px;
                position: relative;
                padding: 0 4px;
                top: -1px;
            }

            .essence {
                background: rgb(215, 17, 17);
            }

            .hot {
                background: rgb(255, 110, 0);
            }

            .content-type-tag {
                font-size: 12px;
                padding: 0 6px;
            }

            .article-tag {
				background-color: #74bded;
			}

			.post-tag {
				background-color: #7ac58b;
			}

            .show-box {
                img {
                    margin-left: 6px;
                }
            }
        }

        .desc {
            color: rgb(51, 51, 51);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            height: 44px;
            margin-top: 10px;
        }
    }

    .hot-box,
    .essence-box {
        position: relative;

        &::after {
            content: "";
            display: block;
            width: 400px;
            height: calc(100% + 1px);
            opacity: 0.6;
            position: absolute;
            right: -40px;
            top: 0;
        }
    }

    .essence-box {
        &::after {
            background: linear-gradient(-64.32deg,
                    rgba(254, 190, 8, 0.21) -2.449%,
                    rgba(196, 196, 196, 0) 96.756%);
        }
    }

    .hot-box {
        &::after {
            background: linear-gradient(-64.32deg,
                    rgba(255, 0, 0, 0.11) -2.446%,
                    rgba(196, 196, 196, 0) 96.716%);
        }
    }

    .userinfo-box {
        height: 32px;
        margin-top: 8px;

        .name {
            font-size: 14px;
            margin-left: 6px;
        }
    }

    .type {
        height: 32px;
        position: relative;
        margin-left: 18px;
        padding: 5px 18px;

        &::after {
            content: "";
            display: block;
            height: 14px;
            width: 1px;
            background-color: #d8d8d8;
            position: absolute;
            top: 50%;
            margin-top: -7px;
            left: 0;
        }

        span {
            display: inline-block;
            height: 22px;
            background-color: #f0f1f1;
            border-radius: 4px;
            padding: 0 4px;
            color: #868d9f;
            line-height: 22px;
            font-size: 12px;
            margin-right: 6px;
        }
    }

    .dates {
        height: 32px;
        line-height: 32px;

        .date {
            font-size: 14px;
            color: #868d9f;
            position: relative;
            padding-left: 16px;

            &::after {
                content: "";
                display: inline-block;
                height: 12px;
                width: 1px;
                background-color: #d8d8d8;
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -6px;
            }
        }

        .comment-list {
            .li {
                color: #868d9f;
                font-size: 14px;
                margin-right: 15px;

                .iconfont {
                    margin-right: 5px;
                }

                .text {}
            }
        }
    }
}

.hot-box {
    padding: 0 40px;
    // margin-top: 9px;

    ::v-deep() {
        .el-input--suffix .el-input__inner {
            border: none;
        }

        .el-radio__inner {
            width: 15px;
            height: 15px;
        }

        .el-radio__label {
            color: rgb(68, 68, 68);
            font-size: 12px;
            line-height: 23px;
            padding-left: 7px;
        }
    }
}

.search-box {
    padding: 6px 40px 2px;

    .s1 {
        color: rgb(25, 25, 25);
        padding-right: 16px;
        min-width: 62px;
        font-size: 14px;
        line-height: 28px;
        font-family: "MicrosoftYaHeiSemibold";
    }

    .desc-list {
        min-height: 32px;

        .span-tab {
            color: rgba(0, 0, 0, 0.9);
            font-size: 14px;
            display: inline-block;
            min-width: 74px;
            padding: 4.5px 16px;
            text-align: center;
            cursor: pointer;
            margin-bottom: 4px;

            &.active {
                border-radius: 21px;
                background: rgb(254, 242, 242);
                color: #b7251e;
            }

            &:hover {
                color: #b7251e;
            }
        }
    }
}

.head-box {
    padding-left: 40px;
    padding-right: 53px;

    .t1 {
        // font-family: "MicrosoftYaHeiSemibold";
        color: rgb(25, 25, 25);
        font-size: 22px;
        line-height: 24px;
    }

    .btn {
    display: inline-block;
        min-width: 84px;
        height: 32px;
        padding: 0 16px;
        border: 1px solid rgb(183, 37, 30);
        border-radius: 20px;
        margin: 0;
        color: #b7251e;
        font-size: 14px;
    }
}

.right-box {
    width: 332px;
}

.left-box {
    width: calc(100% - 348px);
    height: max-content;
    padding: 28px 0 70px;
    border-radius: 12px;
    box-shadow: 0px 4px 48px 0px rgba(0, 0, 0, 0.06);
    background: rgb(255, 255, 255);
}

.container {
    min-height: calc(100vh - 280px);
    padding-top: 60px;
    padding-left: 80px;
    padding-right: 80px;
    background-image: url("../../assets/images/discuss-bg.png");
    background-repeat: no-repeat;
    background-color: #fafafa;

    .discuss-box {
        max-width: 1400px;
        margin: 0 auto;
        padding-top: 20px;
        padding-bottom: 20px;
    }
}

.pageing-box {
    padding: 50px;
}

.jump-ipt {
    box-sizing: border-box;
    /* Light/comp_divider */
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    /* bg/color-bg-1 */
    background: rgb(255, 255, 255);
    width: 28px;
    height: 28px;
}

::v-deep() {
    .el-pagination .jump-text {
        min-width: 10px;
    }

    .el-pager li {
        min-width: 28px;
        margin: 0 4px;
        border-radius: 8px;

        &:hover {
            background: rgb(255, 243, 242);
        }
    }

    .el-pagination .btn-next,
    .el-pagination .btn-prev {
        width: 28px;
        height: 28px;
        border-radius: 8px;
        padding: 0;
        min-width: 28px;
        margin-right: 8px;

        &:hover {
            background: rgb(255, 243, 242);
        }
    }

    .jump-ipt {
        .el-input__inner {
            padding: 0;
            height: 26px;
            line-height: 26px;
            border: none;
            position: relative;
            top: -2px;
            background-color: transparent;
        }
    }

    // .el-input-number.is-without-controls .el-input__inner {
    //     padding: 0;
    //     height: 28px;
    //     border: none;
    // }
}
</style>